import {
  AbsoluteCenter,
  Box,
  chakra,
  Checkbox,
  Flex,
  IconButton,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useDispatch, useSelector } from "react-redux";
import { toggleBGM } from "../../redux/action/action";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import ClearCashButTransfer from "../ClearCash/ClearCashButTransfer";
import i18next from "i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const EndGameDetail = ({
  onClose,
  previousBalance,
  transCode,
  withdrawalNumber,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [isClosing, setIsClosing] = useState(false);
  const [qrcodeModal, setQrcodeModal] = useState(false);
  const [alreadyScan, setAlreadyScan] = useState(false);

  const memberInfo = useSelector((state) => state.isMemberInfo);
  // 只在組件初始化時設置一次時間
  const [currentTime] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
  const navigate = useNavigate();

  const isBGMEnabled = useSelector((state) => state.isBGMEnabled);
  const dispatch = useDispatch();

  // 處理確認按鈕
  const handleConfirm = () => {
    setIsClosing(true);
    dispatch(
      toggleBGM({
        ...isBGMEnabled,
        song: "back2_",
        musicVolume: 0.2,
      })
    );
    navigate("/"); // 導航到首頁
    onClose();
  };

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #804ed2",
    textStroke: "1px #804ed2",
    textShadow: `
    -1px -1px 0 #804ed2,  
     1px -1px 0 #804ed2,
    -1px 1px 0 #804ed2,
     1px 1px 0 #804ed2
  `,
    display: "inline-block",
  };

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="9999"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        w="520px"
        h="480px"
        position={"relative"}
        sx={{
          bgImage: `url('${COMMON_WEB_PATH}/now888/modal/hintBG.webp')`,
          bgPosition: "center",
          bgRepeat: "no-repeat",
          bgSize: "100% 100%",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        p={6}
        // 根據狀態使用不同的動畫
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{ duration: 0.3 }}
        gap={2}
      >
        <AbsoluteCenter
          display="flex"
          fontSize="24px"
          color="white"
          textAlign="center"
          mt={4}
          // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
          top="-20px"
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/modal/give_up_title${
              i18next.language == "tw" ? "" : `_${i18next.language}`
            }.png`}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </AbsoluteCenter>
        {/* 隱形XX */}
        <Box
          position="absolute"
          top="0"
          right="0"
          w="60px"
          h="30px"
          onClick={handleConfirm}
          cursor="pointer"
        ></Box>
        {/* QRcode遮罩 */}
        <ClearCashButTransfer
          onCancelClearCash={onClose}
          transCode={transCode}
        />
        <Flex
          flexDirection="column"
          gap={2}
          justifyContent="center"
          position="relative"
          zIndex={2}
          w="100%"
          pt="25px"
        >
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            h="150px"
            mb="25px"
          >
            <Flex
              justifyContent="center"
              alignItems="center"
              fontSize="36px"
              color="white"
              textAlign="center"
              gap={4}
            >
              {i18n("machineCode")}
              <Text color="#fff" fontWeight="700">
                {"<NO."}
                {memberInfo?.uid || "-"}
                {">"}
              </Text>
            </Flex>
            <Box fontSize="20px" textAlign="center" mt={1}>
              <Text color="#C5B3C7" fontWeight="500">
                {currentTime}
              </Text>
            </Box>
            <Box fontSize="20px" textAlign="center">
              <Flex gap={2} color="#C5B3C7" fontWeight="500">
                <span>{i18n("withdrawNumber")}:</span>
                {withdrawalNumber || "-"}
              </Flex>
            </Box>
          </Flex>
          <Flex justifyContent={"center"}>
            <Image
              w="240px"
              src={`${COMMON_WEB_PATH}/now888/modal/game_result_word${
                i18next.language == "tw" ? "" : `_${i18next.language}`
              }.png`}
            />
          </Flex>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            sx={{
              "& > p": {
                // 應用到所有子Text元素
                background:
                  "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
              },
            }}
            fontSize="32px"
            color="white"
            textAlign="center"
            // mt="-20px"
          >
            <Text color="#FC97FF" fontWeight="700" fontSize="36px">
              {previousBalance || 0}
            </Text>
          </Flex>

          <Flex
            gap={4}
            my={6}
            direction={"column"}
            justifyContent="center"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${COMMON_WEB_PATH}/now888/button/confirm_background.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              cursor="pointer"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
              _hover={{ filter: "brightness(1.1)" }}
            >
              {" "}
              <Image
                src={`${COMMON_WEB_PATH}/now888/button${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/confirm_text.png`}
                width="70px"
                height={{
                  base: "30px",
                  xl: "30px",
                }}
              />
            </Flex>
          </Flex>
        </Flex>
      </ChakraBox>
    </Flex>
  );
};

export default EndGameDetail;
